<template>
    <div>欢迎管理员</div>
</template>

<script>
export default {

}
</script>

<style>

</style>